const transitionDelay = {
    name: "transition-delay",
    path: "/transition-delay",
    title: "transition-delay",
    description: "Utilities for controlling the delay before a transition starts.",
    value: {
        "transition-delay": {
            "delay-<number>": "<number>ms"
        }
    },
    exampleData: [
        {
            example: {
                code: `<button class="transition-all duration-500 delay-200 bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
  200ms Delay
</button>
<button class="transition-all duration-500 delay-1000 bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded mt-4">
  1000ms Delay
</button>`
            }
        }
    ],
    htmlData: [
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">delay-<var>&lt;number&gt;</var></code> to set the transition delay in milliseconds.
      </p>
      <div class="flex gap-4">
        <button class="transition-all hover:scale-125 duration-500 delay-200 bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
          200ms Delay
        </button>
        <button class="transition-all hover:scale-125 duration-500 delay-1000 bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
          1000ms Delay
        </button>
      </div>
      `
        }
    ]
};

export default transitionDelay;
<div className="sr-only transition-all duration-500 delay-200 delay-1000 hover:scale-125"></div>